import React from 'react';
import styles from './ConfirmMoveModalContent.module.scss';
import { CustomButton } from '../Button/Button';
import Icon from '../Icon/Icon';
import { useTranslation } from 'react-i18next';

const ConfirmMoveModalContent = ({ confirmMove, contributorsNumber, onClose, isMultipleVideos }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.modalHeader}>
        <div className={styles.headerContainer}>
          <span className={styles.modalTitle}>{t('confirm_move_modal.header')}</span>
        </div>
        <Icon src="close" className={styles.closeIcon} onClick={onClose} />
      </div>
      <div className={styles.textContainer}>
        <span className={styles.confirmText}>
          {isMultipleVideos ? t('confirm_move_modal.title.plural') : t('confirm_move_modal.title')}
        </span>
        <span className={styles.contributorsText}>
          {t('confirm_move_modal.first_text')} {contributorsNumber} {t('confirm_move_modal.second_text')}
        </span>
      </div>
      <div className={styles.buttonsContainer}>
        <CustomButton variant="secondary" label={t('general.cancel')} onClick={onClose} />
        <CustomButton className={styles.moveBtn} variant="primary" label={t('general.move_anyway')} onClick={confirmMove} />
      </div>
    </>
  );
};

export default ConfirmMoveModalContent;
